import React from 'react';
import { Video, User as UserIcon, LogOut } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

export const Navbar: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="h-16 border-b border-slate-800 bg-[#0c0f17]/80 backdrop-blur px-6 flex items-center justify-between z-10 sticky top-0">
      <div className="flex items-center space-x-3">
        <a href="#/" className="flex items-center space-x-2.5 text-blue-500 font-bold text-xl tracking-tight">
          <div className="w-9 h-9 rounded-xl bg-blue-600/20 border border-blue-500/30 flex items-center justify-center text-blue-400">
            <Video className="w-5 h-5" />
          </div>
          <span className="text-white font-semibold">Cloudflare<span className="text-blue-500 ml-1">Meet</span></span>
        </a>
        <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-blue-500/10 text-blue-400 border border-blue-500/20">
          SFU Realtime
        </span>
      </div>

      {user ? (
        <div className="flex items-center space-x-4">
          <a
            href="#/profile"
            className="flex items-center space-x-2.5 px-3 py-1.5 rounded-lg hover:bg-slate-800/60 transition text-sm text-slate-300 hover:text-white"
          >
            {user.avatarUrl ? (
              <img src={user.avatarUrl} alt={user.name} className="w-7 h-7 rounded-full object-cover border border-slate-700" />
            ) : (
              <div className="w-7 h-7 rounded-full bg-slate-700 flex items-center justify-center text-slate-300">
                <UserIcon className="w-4 h-4" />
              </div>
            )}
            <span className="font-medium">{user.name}</span>
          </a>

          <button
            onClick={() => logout()}
            title="Log out"
            className="p-2 rounded-lg text-slate-400 hover:text-rose-400 hover:bg-rose-500/10 transition"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <div className="flex items-center space-x-3">
          <a
            href="#/login"
            className="px-4 py-2 text-sm font-medium text-slate-300 hover:text-white transition"
          >
            Sign in
          </a>
          <a
            href="#/register"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 rounded-lg shadow-sm transition"
          >
            Get Started
          </a>
        </div>
      )}
    </header>
  );
};
